import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/conversations/$conversationId` activates the DM-thread
// column (col 2). The Conversations LAYOUT route (conversations.tsx) reads
// `$conversationId` from the leaf match and renders every column via
// ColumnLayout. Mirrors forms/$formId.
export const Route = createFileRoute("/$orgSlug/$eventSlug/conversations/$conversationId")({
  component: () => null,
})
